import { render } from "./PreLoginPage.vue?vue&type=template&id=5cfe8e1e&ts=true"
import script from "./PreLoginPage.vue?vue&type=script&lang=ts"
export * from "./PreLoginPage.vue?vue&type=script&lang=ts"

import "./PreLoginPage.vue?vue&type=style&index=0&id=5cfe8e1e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__